<div class="row">
  <div class="col-lg-1"></div>
  <div class="col-lg-10" [formGroup]="broadcastMessage">
    <div class="row col-lg-12">
      <div class="col-lg-6">
        <label class="lbl" [for]="messageLBL">Message<span class="requiredField">*</span> </label>
        <!--<input type="text" kendoTextBox id="messageTxt" formControlName="message" #messageLBL
               class="kendoInput" style="width:100%;" [ngClass]="{'borderRed':broadcastMessagingLbl.isEmptyMessage && broadcastMessagingLbl.isSubmitted}"
               (blur)="validateBroadcastMessageForm()" />-->

        <kendo-textarea resizable="both" id="messageTxt" formControlName="message" #messageLBL
                        class="kendoInput" style="width:100%;" [ngClass]="{'borderRed':broadcastMessagingLbl.isEmptyMessage && broadcastMessagingLbl.isSubmitted}"
                        (blur)="validateBroadcastMessageForm()"></kendo-textarea>
      </div>
    </div>
    <div class="col-lg-12 button-middle">
      <!--<button class="cancel-button" kendoButton (click)="cancel()">Cancel</button>-->
      <button kendoButton class="m-3 clearKendoButton btn btn-success" [icon]="'file-txt'" (click)="broadcastMessageSubmit()">Submit Message</button>

    </div>
  </div>
</div>

<section>
  <kendo-grid [data]="broadcastMessagingGridView"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="broadcastMessagingGridstate.sort"
              (sortChange)="broadcastMessagingGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="broadcastMessagingGridstate.take"
              [skip]="broadcastMessagingGridstate.skip"
              [columnMenu]="false"
              (pageChange)="broadcastMessagingGridPageChange($event)"
              (dataStateChange)="broadcastMessagingDataStateChange($event)"
              [filter]="broadcastMessagingGridstate.filter"
              [loading]="broadcastMessagingLoading">

    <kendo-grid-column field="message" title="{{broadcastMessagingLbl.message}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="messageAddedBy" title="{{broadcastMessagingLbl.added}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>


    <kendo-grid-column field="dateAdded" [width]="135" title="{{broadcastMessagingLbl.addDate}}" [columnMenu]="false"
                       [filterable]="true" [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!--<kendo-grid-command-column title="{{broadcastMessagingLbl.isActive}}" [width]="135" field="isActive">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch (click)="gridSwitchChange(dataItem)" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                      [offLabel]="'No'">
        </kendo-switch>
      </ng-template>
    </kendo-grid-command-column>-->

    <kendo-grid-command-column title="{{broadcastMessagingLbl.action}}" [width]="240" field="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton (click)="broadcastMessageFromGrid(dataItem)">
          Broadcast Message
        </button>

        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>

      </ng-template>
    </kendo-grid-command-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>

</section>

<!--#region - transform array-->
<!--<div>
  Original Array:
  <span>['ABC', 'BCD', 'CDE', 'EFG', 'FGH', 'GHI', 'JKL', 'MNP', 'PQR', 'STD', 'EFG', 'HIJ', 'klo', 'pjd', 'ksd', 'kdk', 'dsd', 'skj', 'kds', 'ddd', 'jjss']</span>
</div>
<table class="table">
  <thead>
    <tr>
      <th scope="col" *ngFor="let item of finalArray[0]; let in = index">Column {{in}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let array of finalArray">
      <td *ngFor="let item of array">{{item}}</td>
    </tr>
  </tbody>
</table>-->
<!--#endregion-->
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.message }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
